import config from '../utils/config'
import request from '../utils/request'

const {api} = config
const {invitation, invitations,invitationSend,
    invitationSendall,invitationSendfirsttime, invitationsEmpty,
    invitationImport,sendEmailMsg,sendCost,invitationOpenedStats,invitationOpened, sendHistoryMsg} = api



/**
 * 导入
 */
export async function importInvitation(params) {
    return request({url: invitationImport, method: 'post', data: params,})
}

/**
 * 查找详情
 */
export async function findInvitation(params) {
    return request({url: invitation, method: 'get', data: params,})
}


/**
 * 删除
 */
export async function deleteInvitation(params) {
    return request({url: invitation, method: 'delete', data: params,})
}

/**
 * 清空
 */
export async function emptyInvitation(params) {
    return request({url: invitationsEmpty, method: 'delete', data: params})
}


/**
 * 查找列表
 */
export async function findInvitations(params) {
    return request({url: invitations, method: 'get', data: params,})
}
/**
 * 编辑被邀请人
 */
export async function updateInvitation(params) {
    return request({url: invitation, method: 'put', data: params,})
}

/**
 * 添加被邀请人
 */
export async function createInvitation(params) {
    return request({url: invitations, method: 'post', data: params,})
}

/**
 * 勾选发送
 */
export async function sendInvitation(params) {
    return request({url: invitationSend, method: 'post', data: params,})
}
/**
 * 全部发送
 */
export async function sendallInvitation(params) {
    return request({url: invitationSendall, method: 'post', data: params,})
}
/**
 * 发送未发送
 */
export async function sendfirsttimeInvitation(params) {
    return request({url: invitationSendfirsttime, method: 'post', data: params,})
}
/**
 * 发送邮件
 */
export async function sendEmail(params) {
    return request({url: sendEmailMsg, method: 'post', data: params,})
}/**
 * 计算条数
 */
export async function countCost(params) {
    return request({url: sendCost, method: 'post', data: params,})
}

/**
 * 发送邮件
 */
export async function sendMsgHistory(params) {
    return request({url: sendHistoryMsg, method: 'post', data: params,})
}
/**
 * 发送打开统计
 */
export async function findInvitationOpenedStats(params) {
    return request({url: invitationOpenedStats, method: 'get', data: params,})
}
export async function signInvitationOpened(params) {
    return request({url: invitationOpened, method: 'post', data: params,})
}




// WEBPACK FOOTER //
// ./src/services/invitation.js